import React from "react";
import { Box } from "../elements/Box";
import { Flex } from "../elements/Flex";
import { Grid } from "../elements/Grid";
import { Heading } from "../elements/Heading";
import { Image } from "../elements/Image";
import { Text } from "../elements/Text";
import green from "../images/v2/svgs/bubbles/green.svg";
import pink from "../images/v2/svgs/bubbles/pink.svg";
import purple from "../images/v2/svgs/bubbles/purple.svg";

const stats = [
  {
    label: "Followers",
    amount: "3.2M",
    bubble: pink,
  },
  {
    label: "Downloads",
    amount: "650k+",
    bubble: green,
  },
  {
    label: "4.7* App rating",
    amount: "1K+",
    bubble: purple,
  },
];

const AppStatistics = () => {
  return (
    <Grid
      width="100%"
      maxWidth="900px"
      margin="0 auto"
      display={["block", "grid"]}
      py={4}
      px={[3, 0]}
      gridTemplateColumns="repeat(3,1fr)"
    >
      {stats.map(({ label, amount, bubble }, index) => (
        <Flex position="relative" p={2} key={label} textAlign="center" justifyContent="center" justifySelf="center">
          <Image src={bubble} width={index === 1 ? "12rem" : "10rem"} maxWidth={index === 1 ? "275px" : "200px"} />

          <Flex
            flexDirection="column"
            zIndex={10}
            width="100%"
            justifyContent="center"
            alignItems="center"
            height="100%"
            position="absolute"
            top={0}
            color="white"
          >
            <Heading fontSize={24}>{amount}</Heading>
            <Text fontSize={12}>{label}</Text>
          </Flex>
        </Flex>
      ))}
    </Grid>
  );
};

export default AppStatistics;
